module.exports = __webpack_public_path__ + "static/looogo-be5fc51e6c7f4c338a5c5b90a3e3dbdb.png";